/**
 * @generated SignedSource<<e5108b7adcef025c5ac838a80f1c33b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvitationKind = "admin" | "member" | "%future added value";
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
export type useStartCheckoutQuery$variables = {
  id?: string | null;
  occurrenceId?: string | null;
  organizationSlug: string;
  slug?: string | null;
};
export type useStartCheckoutQuery$data = {
  readonly product: {
    readonly cover: string;
    readonly description: string | null;
    readonly id: string;
    readonly landingPage: {
      readonly id: string;
      readonly metaDescription: string | null;
      readonly metaImageUrl: string | null;
      readonly metaTitle: string | null;
    } | null;
    readonly myCheckout: {
      readonly application: {
        readonly answers: ReadonlyArray<string>;
      } | null;
      readonly hasApplication: boolean;
      readonly id: string;
      readonly invitation: {
        readonly kind: InvitationKind;
        readonly message: string;
        readonly organizationId: string;
        readonly productId: string | null;
      } | null;
      readonly isOrganizationPublic: boolean | null;
      readonly occurrence: {
        readonly allowGuestAccess: boolean;
        readonly id: string;
      } | null;
      readonly organizationForm: {
        readonly answers: ReadonlyArray<string>;
      } | null;
      readonly profile: {
        readonly email: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly timezone: string | null;
        readonly userId: string | null;
      };
      readonly quote: {
        readonly basePrice: number;
        readonly currency: string;
        readonly discount: {
          readonly code: string | null;
          readonly id: string;
        } | null;
        readonly finalPrice: number;
      };
      readonly " $fragmentSpreads": FragmentRefs<"CheckoutFormApplicationSection_Checkout" | "CheckoutFormDiscountInput_Checkout" | "CheckoutFormOrganizationFormSection_Checkout" | "ProductRegistrationPaymentStep_Checkout" | "ProductRegistrationProfileStep_Checkout">;
    } | null;
    readonly name: string;
    readonly slug: string;
    readonly type: ProductType;
    readonly " $fragmentSpreads": FragmentRefs<"CheckoutFormRegistrationErrorStep_Product" | "ProductOnboardingInfoSection_Product">;
  } | null;
};
export type useStartCheckoutQuery = {
  response: useStartCheckoutQuery$data;
  variables: useStartCheckoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "occurrenceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationSlug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "occurrenceId",
    "variableName": "occurrenceId"
  },
  {
    "kind": "Variable",
    "name": "organizationSlug",
    "variableName": "organizationSlug"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasApplication",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrganizationPublic",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "CheckoutProfile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basePrice",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalPrice",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Occurrence",
  "kind": "LinkedField",
  "name": "occurrence",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowGuestAccess",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answers",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaTitle",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaDescription",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaImageUrl",
  "storageKey": null
},
v28 = [
  (v5/*: any*/)
],
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutQuestion",
    "kind": "LinkedField",
    "name": "questions",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "richEditorBody",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v19/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useStartCheckoutQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductOnboardingInfoSection_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CheckoutFormRegistrationErrorStep_Product"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Checkout",
            "kind": "LinkedField",
            "name": "myCheckout",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProductRegistrationPaymentStep_Checkout"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProductRegistrationProfileStep_Checkout"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CheckoutFormDiscountInput_Checkout"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CheckoutFormApplicationSection_Checkout"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CheckoutFormOrganizationFormSection_Checkout"
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuote",
                "kind": "LinkedField",
                "name": "quote",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Discount",
                    "kind": "LinkedField",
                    "name": "discount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuestionAnswers",
                "kind": "LinkedField",
                "name": "application",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuestionAnswers",
                "kind": "LinkedField",
                "name": "organizationForm",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Invitation",
                "kind": "LinkedField",
                "name": "invitation",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandingPage",
            "kind": "LinkedField",
            "name": "landingPage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useStartCheckoutQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "richEditorCheckoutDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "landingPageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandingPage",
            "kind": "LinkedField",
            "name": "landingPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mode",
                "storageKey": null
              },
              (v5/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registrationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "waitlistUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "waitlistCtaLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductMembership",
            "kind": "LinkedField",
            "name": "viewerMembership",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "viewerMembershipPlan",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChangeMembershipPlan",
                    "kind": "LinkedField",
                    "name": "viewerCanChangeMembershipPlan",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Checkout",
            "kind": "LinkedField",
            "name": "myCheckout",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pricing",
                    "kind": "LinkedField",
                    "name": "pricing",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "frequency",
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountCents",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "viewerActiveMembershipPlan",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuote",
                "kind": "LinkedField",
                "name": "quote",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Discount",
                    "kind": "LinkedField",
                    "name": "discount",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueKind",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueAmount",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuestionAnswers",
                "kind": "LinkedField",
                "name": "application",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutQuestionAnswers",
                "kind": "LinkedField",
                "name": "organizationForm",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Invitation",
                "kind": "LinkedField",
                "name": "invitation",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "29a61d0701200ab7476a46c7c604f189",
    "id": null,
    "metadata": {},
    "name": "useStartCheckoutQuery",
    "operationKind": "query",
    "text": "query useStartCheckoutQuery(\n  $id: ID\n  $slug: String\n  $organizationSlug: String!\n  $occurrenceId: ID\n) {\n  product(id: $id, slug: $slug, organizationSlug: $organizationSlug, occurrenceId: $occurrenceId) {\n    id\n    type\n    name\n    cover\n    slug\n    description\n    ...ProductOnboardingInfoSection_Product\n    ...CheckoutFormRegistrationErrorStep_Product\n    myCheckout {\n      id\n      ...ProductRegistrationPaymentStep_Checkout\n      ...ProductRegistrationProfileStep_Checkout\n      ...CheckoutFormDiscountInput_Checkout\n      ...CheckoutFormApplicationSection_Checkout\n      ...CheckoutFormOrganizationFormSection_Checkout\n      hasApplication\n      isOrganizationPublic\n      profile {\n        userId\n        email\n        firstName\n        lastName\n        timezone\n      }\n      quote {\n        basePrice\n        finalPrice\n        currency\n        discount {\n          id\n          code\n        }\n      }\n      occurrence {\n        id\n        allowGuestAccess\n      }\n      application {\n        answers\n      }\n      organizationForm {\n        answers\n      }\n      invitation {\n        kind\n        message\n        productId\n        organizationId\n        id\n      }\n    }\n    landingPage {\n      id\n      metaTitle\n      metaDescription\n      metaImageUrl\n    }\n  }\n}\n\nfragment CheckoutFormApplicationSection_Checkout on Checkout {\n  application {\n    questions {\n      id\n      richEditorBody\n    }\n  }\n}\n\nfragment CheckoutFormDiscountInput_Checkout on Checkout {\n  quote {\n    discount {\n      id\n      code\n    }\n  }\n}\n\nfragment CheckoutFormOrganizationFormSection_Checkout on Checkout {\n  organizationForm {\n    questions {\n      id\n      richEditorBody\n    }\n  }\n}\n\nfragment CheckoutFormRegistrationErrorStep_Product on Product {\n  type\n  slug\n  landingPageUrl\n  registrationType\n  waitlistUrl\n  waitlistCtaLabel\n  viewerMembership {\n    id\n  }\n  organization {\n    ...MembershipPlanSelectButton_OrganizationFragment\n    id\n  }\n}\n\nfragment Discount_displayValue on Discount {\n  valueKind\n  valueAmount\n}\n\nfragment MembershipPlanSelectButton_OrganizationFragment on Organization {\n  id\n  viewerMembershipPlan {\n    id\n    viewerCanChangeMembershipPlan {\n      value\n      message\n    }\n  }\n}\n\nfragment PaymentFormDiscountSection_Discount on Discount {\n  ...Discount_displayValue\n}\n\nfragment PaymentFormDiscountSection_Pricing on Pricing {\n  frequency\n  ...pricingUtils_usePricingDisplayValue\n}\n\nfragment ProductOnboardingInfoSection_Product on Product {\n  name\n  cover\n  startsAt\n  type\n  richEditorCheckoutDescription\n  landingPageUrl\n  landingPage {\n    mode\n    id\n  }\n}\n\nfragment ProductRegistrationPaymentStep_Checkout on Checkout {\n  id\n  product {\n    type\n    pricing {\n      ...PaymentFormDiscountSection_Pricing\n      id\n    }\n    organization {\n      viewerActiveMembershipPlan {\n        id\n      }\n      id\n    }\n    id\n  }\n  quote {\n    basePrice\n    finalPrice\n    discount {\n      ...PaymentFormDiscountSection_Discount\n      id\n    }\n  }\n}\n\nfragment ProductRegistrationProfileStep_Checkout on Checkout {\n  id\n  product {\n    organization {\n      viewerActiveMembershipPlan {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment pricingUtils_usePricingDisplayValue on Pricing {\n  frequency\n  kind\n  amountCents\n}\n"
  }
};
})();

(node as any).hash = "926d7459c8db81a137f0a13b302829c0";

export default node;
